import { useEffect, useState, useMemo, useRef } from 'react';
import { useSweetAlert } from '../sweetAlerts/useSweetAlert';
import { useParams } from 'react-router-dom';
import { getInformationQuoterDeterminations } from '../../services/microsanitaria/catalogosMic'
import { saveSampling, getTypeSamples, getSites, getAreas, getSamples, getThermometers, saveQuoter, saveWorkOrderMicro, saveSampleM, saveSite, saveUpdateSampling } from '../../services/microsanitaria/micSampling'
import { OperationsAmounts } from '../../utils/validations/calculateWithTax';
import { getAllPayMethod } from '../../services/payMethod/payMethod'
import { useHistory } from 'react-router-dom';
import moment from 'moment';
import { sendRequest } from '../requests/useRequest';
import { validarSesion } from '../tokens/useToken';
import { pyrsa } from '../../constant/globalConstantsTypeClients';


export const useMicSampling = () => {

    // ? CONFIGURATION
    const { code_Quatation } = useParams();
    const history = useHistory();
    const [createSweet, , , , createSweett] = useSweetAlert();
    const minDate = moment();

    let id_branch = localStorage.getItem('branchId');
    let id_commercial_line = localStorage.getItem("commercialLineId");
    let url_helen = localStorage.getItem('url_helen');
    let nameBranch = localStorage.getItem('branchName')

    // ! CONFIGURATION CEDIMI
    const [loadingCedimi, setLoadingCedimi] = useState(false)

    // * MODAL CREATE SAMPLE
    const [modalSample, setModalSample] = useState(false);
    const [nameSampling, setNameSampling] = useState(null)

    // * MODAL CREATE SITE
    const [modalSite, setModalSite] = useState(false);
    const [nameSite, setNameSite] = useState(null)

    //*INFORMATION GENERAL QUATATION
    const [loadingQuoter, setLoadingQuoter] = useState(false);
    const [loadingMic, setLoadingMic] = useState(false);

    //*TOGGLE NOT COLLECTED SANPLE
    const [modalCollected, setModalCollected] = useState(false);
    const [dataCollected, setDataCollected] = useState([]);

    // *SAMPLE FORM
    const [listSite, setListSite] = useState([]);
    const [listArea, setListArea] = useState([]);
    const [listSample, setListSample] = useState([]);
    const [listThermometer, setListThermometer] = useState([]);
    const [loadingSamplings, setLoadingSamplings] = useState(false);
    const [listNot, setListNot] = useState([])

    //*MODAL SAVE SAMPLINGS
    const [modalSamplings, setModalSamplings] = useState(false);

    //* FIRMS
    const canvasRef1 = useRef(null);
    const canvasRef2 = useRef(null);
    const canvasRef3 = useRef(null);

    //* TOGGLE SAVE SAMPLINGS
    const [modalValid, setModalValid] = useState(false);

    //* USERS
    const [users, setUsers] = useState([]);
    const [loadingUsers, setLoadingUsers] = useState(false);
    const [mSelectUser, setMSelectUser] = useState(null);

    const [listPay, setListPay] = useState([]);
    const [total_tax, setTotal_tax] = useState(0)

    //? CUSTOM ALERT GLOBAL
    const [customAlert, setCustomAlert] = useState({
        visible: false,
        mode: "alert",
        type: "info",
        title: "",
        message: "",
        showDatePicker: false,
        study_delivery: "",
        onAccept: null,
        onCancel: null
    });

    const [optionsTotal, setOptionsTotal] = useState({
        subtotal: 0,
        tax: 0,
        total: 0
    });

    // ? CALCULATE PRICES
    const [optionsPayment, setOptionsPayment] = useState({
        listPayMethods: [{
            id_pay_method: 0,
            amount: 0,
            id_branch: id_branch
        }]
    });

    //*FOMR MIC
    const [formMicSampling, setFormMicSampling, handleUpdateValuesWorkOrder] = useState({
        samples: [],
        code: null,
        id_quoter: null,
        no_samples: null,
        firm_client: null,
        firm_sampler: null,
        firm_superv: null,
        observations: null,
        sample_Form: [],
        is_form: false,
        is_view: 1,
        sample_Detail: [],
        is_detail: false,
        is_determination: false,
        quoter: {},
        firm_client_png: null,
        firm_sampler_png: null,
        firm_superv_png: null,
        sampling_plan: null,
        is_company: null,
        is_invoice: false,
        validate_cancell: false,
        require_invoice: false,
        available_invoice_patient: false,
        payment_by_patient: false,
        payment_by_company: false,
        payment_company: null,
        is_edit_site: false,
        is_edit_id_mic_sample: false,
        is_edit_thermometer: false,
        study_delivery: "",

    })

    //!DATA 
    useEffect(() => {
        getSearchFilter()
        getPayMethod()
        getUsers();

    }, [])

    const showCustomAlertConfirm = ({
        type = "warning",
        title,
        message,
        buttonText = "Aceptar",
        cancelText = "Cancelar",
        showDatePicker = false
    }) => {

        return new Promise((resolve) => {

            setCustomAlert({
                visible: true,
                mode: "confirm",
                type,
                title,
                message,
                buttonText,
                cancelText,
                showDatePicker,
                study_delivery: formMicSampling.study_delivery,

                onAccept: (fecha) => {

                    setCustomAlert(prev => ({
                        ...prev,
                        visible: false
                    }));

                    resolve(fecha);
                },

                onCancel: () => {

                    setCustomAlert(prev => ({
                        ...prev,
                        visible: false
                    }));

                    resolve(null);
                }
            });

        });

    };

    const formatAmount = (amount, decimals) => {
        return parseFloat(
            (Math.trunc(amount * 100000000) / 100000000).toFixed(decimals),
        );
    }

    //*CALCULATE AMOUNT
    useMemo(() => {

        if (formMicSampling.samples?.length > 0) {
            let subtotal = 0;
            let taxes = 0;
            let total = 0;
            let _valid = ""

            formMicSampling.samples.forEach(_find => {

                if (!_find?.not_collected && _find?.id_mic_sampling !== null) {

                    setTotal_tax(_find?.value_iva)

                    switch (_find?.config_iva) {
                        case true:
                            if (_find?.discount !== 0) {

                                if (formMicSampling?.is_company !== null) {
                                    _valid = OperationsAmounts(1, _find?.price, true, _find?.value_iva, 0)
                                }
                                else _valid = OperationsAmounts(1, _find?.discount, true, _find?.value_iva, 0)
                            }
                            else _valid = OperationsAmounts(1, _find?.price, true, _find?.value_iva, 0)

                            // ? TOTAL
                            _find.discount_tota = _valid.total
                            _find.can_total = _valid.total
                            subtotal += _valid.subtotal;
                            taxes += _valid.total_tax
                            total += _valid.total

                            break;
                        default:
                            if (_find?.discount !== 0) {
                                _valid = OperationsAmounts(1, _find?.price, false, _find?.value_iva, 0)
                            }
                            else _valid = OperationsAmounts(1, _find?.price, false, _find?.value_iva, _find?.discount)

                            // ? TOTAL
                            _find.discount_tota = _valid.total
                            _find.can_total = _valid.total
                            subtotal += _valid.subtotal;
                            taxes += _valid.total_tax
                            total += _valid.total
                            break;
                    }
                }
            })
            setOptionsTotal({
                subtotal: formatAmount(subtotal, 2),
                tax: formatAmount(taxes, 2),
                //total: Math.round(formatAmount(total, 2))
                total: formatAmount(total, 2)
            })
        }
    }, [formMicSampling])


    useEffect(() => {
        // ? VALDATION COMPANY
        if (formMicSampling?.is_company !== null) {

            if (formMicSampling?.payment_company) {

                const _total = optionsTotal?.total;

                setOptionsPayment(prev => ({
                    ...prev,
                    listPayMethods: prev.listPayMethods.length > 0
                        ? [
                            {
                                ...prev.listPayMethods[0],
                                amount: _total,
                                id_pay_method: 10
                            },
                            ...prev.listPayMethods.slice(1)
                        ]
                        : [
                            {
                                id_pay_method: 10,
                                amount: _total,
                                id_branch: id_branch
                            }
                        ]
                }));
            }
            else {
                setOptionsPayment(prev => ({
                    ...prev,
                    listPayMethods: [{
                        id_pay_method: 0,
                        id_branch: id_branch
                    }]
                }));
            }
        }
    }, [formMicSampling, optionsTotal]);


    const toggleSample = () => {
        setModalSample(!modalSample)
    }

    const handleNewSample = () => {
        toggleSample()
    }

    const handleText = (_value) => {
        setNameSampling(_value)
    }

    const toggleSite = () => {
        setModalSite(!modalSite)
    }

    const handleNewSite = () => {
        toggleSite()
    }

    const handleTextSite = (_value) => {
        setNameSite(_value)
    }

    const handleView = async (_view) => {
        if (_view !== null && _view !== "") {
            if (_view === 1) {
                setFormMicSampling({
                    ...formMicSampling,
                    is_view: _view,
                    is_detail: true
                })
            }
            else {
                if (_view === 2) {
                    if (listNot.length > 0) {
                        handleToggleValid();
                        setFormMicSampling({
                            ...formMicSampling,
                            is_view: 1,
                            is_detail: true
                        })
                        return;
                    }
                }
                setFormMicSampling({
                    ...formMicSampling,
                    is_view: _view,
                    is_detail: false
                })
            }
        }
    }

    const getPayMethod = async (_type) => {
        const pay = await getAllPayMethod(3);

        if (pay?.length > 0) {
            const list = pay?.map(_find => {
                return {
                    id_pay_method: _find?.id_pay_method,
                    name: _find?.abbreviation + "-" + _find?.name,
                }
            });
            setListPay(list);
        }
    }

    const getSearchFilter = async (_valid, _valid2) => {
        if (code_Quatation !== "" && code_Quatation !== undefined && code_Quatation !== null) {

            if (_valid === undefined) {
                setLoadingQuoter(true);
            } else {
                setLoadingSamplings(true);
            }

            const quoter = await getInformationQuoterDeterminations(code_Quatation);

            if (quoter !== null) {

                if (_valid) {
                    createSweet("success", "success", "Se guardo correctamente");
                    setLoadingSamplings(false);
                    handleToggleSamplings(); // ? CONFIGUARATION   
                }

                if (quoter?.samples?.length > 0) {
                    // ? FIND SAMPLING

                    const sample = await getTypeSamples();
                    const _listSamplings = sample.map(_find => {
                        return {
                            id_mic_type_sample: _find?.id_mic_type_sample,
                            name: _find?.name
                        }
                    })

                    let _prueba = {}

                    const _alid = quoter?.samples?.map(sample => {
                        if (sample.id_mic_detail_sample === null) {
                            return {
                                folio: sample.folio
                            };
                        }
                        return null;
                    }).filter(Boolean);

                    if (_alid.length > 0) {
                        setListNot(_alid);
                    } else {
                        setListNot([]);
                    }

                    const _valid = quoter?.samples?.map(_valid => {
                        let _name = _listSamplings.find(x => x.id_mic_type_sample === _valid?.id_mic_type_sample);

                        const _determinations = _valid?.listDeterminations.map(_info => {
                            return {
                                name: _info?.name ?? "---",
                                new_determination: _info?.new_determination ?? "---",
                                list_nom: _info?.list_nom ?? [],
                                listIndication: _info?.listIndication ?? [],
                            }
                        })

                        const _newView = quoter.samples.reduce((latest, current) => {
                            return (!latest || (new Date(current?.date_collected) > new Date(latest?.date_collected))) ? current : latest;
                        }, null);

                        if (_newView) {
                            const _name = _listSamplings.find(x => x.id_mic_type_sample === _newView?.id_mic_type_sample);

                            const _determinations = _newView?.listDeterminations.map(_info => ({
                                name: _info?.name ?? "---",
                                new_determination: _info?.new_determination ?? "---",
                                list_nom: _info?.list_nom ?? [],
                                listIndication: _info?.listIndication ?? [],
                            }));

                            _prueba = {
                                id_quoter_type_sample: _newView?.id_quoter_type_sample ?? null,
                                id_mic_type_sample: _newView?.id_mic_type_sample ?? null,
                                folio: _newView?.folio ?? "----",
                                id_quoter: quoter?.cotizacion?.id_quoter ?? null,
                                id_mic_detail_sample: _newView?.id_mic_detail_sample ?? null,
                                id_mic_sampling: _newView?.id_mic_sampling ?? null,
                                id_mic_site: _newView.id_mic_site ?? null,
                                id_mic_site_areas: _newView.id_mic_site_areas ?? null,
                                id_mic_sample: _newView?.id_mic_sample ?? null,
                                id_patient: _newView?.id_patient ?? null,
                                id_thermometer: _newView?.id_thermometer ?? null,
                                temperature: _newView?.temperature ?? null,
                                quantity: _newView?.quantity ?? null,
                                factor_correction: _newView?.factor_correction ?? null,
                                observations: _newView?.observations ?? null,
                                not_collected: _newView?.not_collected ?? null,
                                date_collected: _newView?.date_collected ?? null,
                                required_temperature: _newView?.required_temperature,
                                list_Determinations: _determinations,
                                name_Sampling: _name,
                                name_mic_sample: _newView?.name_mic_sample ?? null,
                                name_mic_site: _newView?.name_mic_site ?? null,
                                name_mic_site_areas: _newView?.name_mic_site_areas ?? null,
                                name_thermometer: _newView?.name_thermometer ?? null,
                                subject: _newView?.subject ?? null,
                                date_sampling: quoter?.cotizacion?.date_sampling ?? null,
                                name_company: quoter?.cotizacion?.name_company ?? null
                            };
                        }
                        return {
                            id_quoter_type_sample: _valid?.id_quoter_type_sample ?? null,
                            id_mic_type_sample: _valid?.id_mic_type_sample ?? null,
                            folio: _valid?.folio ?? "----",
                            id_quoter: quoter?.cotizacion?.id_quoter ?? null,
                            id_mic_detail_sample: _valid?.id_mic_detail_sample ?? null,
                            id_mic_sampling: _valid?.id_mic_sampling ?? null,
                            id_mic_site: _valid.id_mic_site ?? null,
                            id_mic_site_areas: _valid.id_mic_site_areas ?? null,
                            id_mic_sample: _valid?.id_mic_sample ?? null,
                            id_patient: _valid?.id_patient ?? null,
                            id_thermometer: _valid?.id_thermometer ?? null,
                            temperature: _valid?.temperature ?? null,
                            quantity: _valid?.quantity ?? null,
                            factor_correction: _valid?.factor_correction ?? null,
                            observations: _valid?.observations ?? null,
                            not_collected: _valid?.not_collected ?? null,
                            date_collected: _valid?.date_collected ?? null, // ? estatus
                            required_temperature: _valid?.required_temperature,
                            list_Determinations: _determinations,
                            name_Sampling: _name,
                            name_mic_sample: _valid?.name_mic_sample ?? null,
                            name_mic_site: _valid?.name_mic_site ?? null,
                            name_mic_site_areas: _valid?.name_mic_site_areas ?? null,
                            name_thermometer: _valid?.name_thermometer ?? null,
                            config_iva: _valid?.config_iva ?? false,
                            discount: _valid?.discount ?? 0,
                            price: _valid?.price ?? 0,
                            value_iva: _valid?.value_iva ?? 16,
                            subject: _valid?.subject ?? null,
                        }
                    })

                    setFormMicSampling({
                        ...formMicSampling,
                        samples: _valid ?? [],
                        code: quoter?.cotizacion?.code ?? null,
                        id_quoter: quoter?.cotizacion?.id_quoter ?? null,
                        no_samples: quoter?.cotizacion?.no_samples ?? null,
                        observations: quoter?.observations ?? null,
                        sample_Form: [],
                        is_form: false,
                        quoter: quoter?.cotizacion,
                        firm_client_png: quoter?.firm_client ?? null,
                        firm_sampler_png: quoter?.firm_sampler ?? null,
                        firm_superv_png: quoter?.firm_superv ?? null,
                        sampling_plan: quoter?.sampling_plan ?? null,
                        sample_Detail: _prueba ?? [],
                        is_detail: true,
                        is_company: quoter?.cotizacion?.id_company === 0 ? null : quoter?.cotizacion?.id_company ?? null,
                        require_invoice: quoter?.cotizacion?.require_invoice ?? false,
                        available_invoice_patient: quoter?.cotizacion?.available_invoice_patient ?? false,
                        payment_by_patient: quoter?.cotizacion?.payment_by_patient ?? false,
                        payment_by_company: quoter?.cotizacion?.payment_by_company ?? false,
                        payment_company: quoter?.cotizacion?.id_company === null ? false : (quoter?.cotizacion?.payment_by_patient && quoter?.cotizacion?.payment_by_company) === true ? null : quoter?.cotizacion?.payment_by_patient === false ? true : false
                    });
                    setLoadingQuoter(false);

                }
            }
            else {
                if (_valid === undefined) {
                } else {
                    setLoadingSamplings(true);


                }
            }
        }
    }

    //*TOGGLE EXAMS
    const handleToggleCollected = () => {
        setModalCollected(!modalCollected)
    }

    const handleNotCollected = (_id_quoter_type_sample) => {

        if (_id_quoter_type_sample !== null && _id_quoter_type_sample !== undefined && _id_quoter_type_sample !== "") {
            let _valid = formMicSampling?.samples.find(x => x.id_quoter_type_sample === _id_quoter_type_sample);

            setDataCollected({
                folio: _valid?.folio ?? "----",
                id_quoter_type_sample: _valid?.id_quoter_type_sample ?? null,
                id_mic_type_sample: _valid?.id_mic_type_sample ?? null
            })
            handleToggleCollected();
        }
        else createSweet("wanirnig", "warning", "Muestra", "No se puede seleccionar este muestra.");
    };

    const saveDetailSamplingsNotCollected = async (_folio, _id_quoter_type_sample, _id_mic_type_sample) => {

        if (_folio !== null && _id_quoter_type_sample !== null) {

            const response = await saveSampling({
                date_collected: "",
                factor_correction: 0,
                folio: _folio,
                id_mic_detail_sample: null,
                id_mic_sample: null,
                id_mic_sampling: null,
                id_mic_site: null,
                id_mic_site_areas: null,
                id_mic_type_sample: _id_mic_type_sample,
                id_patient: null,
                id_quoter: formMicSampling.id_quoter,
                id_quoter_type_sample: _id_quoter_type_sample,
                id_thermometer: null,
                not_collected: true,
                observations: "",
                quantity: "",
                required_temperature: false,
                temperature: ""
            });

            if (response.code === 200) {
                getSearchFilter()
                handleToggleCollected();

            } else createSweet("wanirnig", "warning", response?.data?.message);

        } else createSweet("wanirnig", "warning", "Muestra", "No se pudo actualizar correctamente.");
    }

    // * SAMPLE FORM 
    const handleSearchSampling = (_id_quoter_type_sample) => {
        if (_id_quoter_type_sample !== null && _id_quoter_type_sample !== "" && _id_quoter_type_sample !== undefined) {

            setMSelectUser(null);
            let _search = formMicSampling?.samples.find(x => x.id_quoter_type_sample === _id_quoter_type_sample);

            if (_search !== null) {
                setFormMicSampling({
                    ...formMicSampling,
                    sample_Form: _search,
                    is_form: true,
                    is_edit: false
                });
                // ? CONFIGURATION CATALOGS
                getTypeSites();
                getSamplesList();
            }
            else {
                setFormMicSampling({
                    ...formMicSampling,
                    sample_Form: _search,
                    is_form: false
                });
            }
        }
        else createSweet("warning", "warning", "Muestreo", "No se encontro ningún resultado");
    }

    const editSearchSampling = async (_id_quoter_type_sample) => {
        if (_id_quoter_type_sample !== null && _id_quoter_type_sample !== "" && _id_quoter_type_sample !== undefined) {

            let _search = formMicSampling?.samples.find(x => x.id_quoter_type_sample === _id_quoter_type_sample);

            if (_search !== null) {
                setFormMicSampling({
                    ...formMicSampling,
                    sample_Form: _search,
                    is_form: true,
                    is_edit: true,
                    is_edit_site: true,
                    is_edit_id_mic_sample: true,
                    is_edit_thermometer: true
                });
                // ? CONFIGURATION CATALOGS
                getTypeSites();
                getSamplesList();
                getTypeThermometers()
                const thermometers = await getThermometers();

                let _valid = thermometers.find(x => x.id_thermometer === _search?.id_thermometer);

                if (_valid !== null && _valid !== undefined) {

                    handleChangeThermometers({ value: _search?.id_thermometer, label: _search?.name_thermometer, factor: _valid?.correction_factor }, true)
                    handleChangeTemperature({ target: { value: _search?.temperature } }, _valid?.correction_factor)
                }

            }
            else {
                setFormMicSampling({
                    ...formMicSampling,
                    sample_Form: _search,
                    is_form: false,
                    is_edit_site: false
                });
            }
        }
        else createSweet("warning", "warning", "Muestreo", "No se encontro ningún resultado");

    }







    const handleResetSamplings = () => {
        const _validForm = formMicSampling?.sample_Form;

        if (_validForm?.id_mic_sample != null ||
            _validForm?.id_mic_site != null ||
            _validForm?.id_mic_site_areas ||
            _validForm?.observations ||
            _validForm?.quantity
        ) {
            setFormMicSampling(prev => ({
                ...prev,
                validate_cancell: true
            }));

            setModalSamplings(true);
        }
        else {
            setFormMicSampling(prev => ({
                ...prev,
                sample_Form: [],
                is_form: false,
                validate_cancell: false
            }));
        }
    }

    // ? SAVE CANCELL

    const cancell_Samplings = () => {
        setFormMicSampling({
            ...formMicSampling,
            sample_Form: [],
            is_form: false,
            validate_cancell: false
        });
        handleToggleSamplings()
    }

    // #region CONFIGURATION CATALOGS
    const getTypeSites = async () => {
        const site = await getSites();

        if (site?.length > 0) {
            const list = site?.map(_find => {
                return {
                    value: _find?.id_mic_site,
                    label: _find?.name,
                }
            });
            setListSite(list);
        }
        else createSweet("warning", "warning", "Muestra", "Sin resultados");
    }

    const handleChangeSites = async (e) => {
        if (e !== null && e?.value !== undefined && e?.value !== "") {
            const selectedIdMicSite = e?.value;

            setFormMicSampling(_search => ({
                ..._search,
                sample_Form: {
                    ..._search?.sample_Form,
                    id_mic_site: {
                        value: e?.value,
                        label: e?.label,
                    },
                    id_mic_site_areas: null
                },
                is_edit_site: false
            }));

            const area = await getAreas(selectedIdMicSite);

            if (area !== null) {
                const list = area?.map(_find => {
                    return {
                        value: _find?.id_mic_site_area,
                        label: _find?.name,
                    }
                });
                setListArea(list);
            }
            else createSweet("warning", "warning", "Sitio", "Sin resultados");
        }
        else createSweet("warning", "warning", "Sitio", "Sin resultados");
    };

    const handleChangeArea = async (e, isEdit) => {
        if (e !== null && e?.value !== undefined && e?.value !== "") {

            setFormMicSampling(_search => ({
                ..._search,
                sample_Form: {
                    ..._search?.sample_Form,
                    id_mic_site_areas: {
                        value: e.value,
                        label: e?.label,
                    }
                },
                is_edit: false

            }));
        }
        else createSweet("warning", "warning", "Area", "Sin resultados");
    };

    const getSamplesList = async () => {
        const sample = await getSamples();

        if (sample?.length > 0) {
            const list = sample?.map(_find => {
                return {
                    value: _find?.id_mic_sample,
                    label: _find?.name,
                }
            });
            setListSample(list);
        }
        else createSweet("warning", "warning", "Muestra", "Sin resultados");
    }

    const handleChangeSample = async (e) => {
        if (e !== null && e?.value !== undefined && e?.value !== "") {

            setFormMicSampling(_search => ({
                ..._search,
                sample_Form: {
                    ..._search?.sample_Form,
                    id_mic_sample: {
                        value: e?.value,
                        label: e?.label,
                    }
                },
                is_edit_id_mic_sample: false
            }));
        } else createSweet("warning", "warning", "Area", "Sin resultados");
    };

    // #endregion

    // #region SAVE CREATE SAMPLE
    // ? CONFIGURATION SUBJECT
    const handleChangeSubject = async (e) => {
        const _subject = e?.target?.value;

        if (e !== null && e?.target?.value !== undefined && e?.target?.value !== "") {
            setFormMicSampling(_search => ({
                ..._search,
                sample_Form: {
                    ..._search?.sample_Form,
                    subject: _subject
                }
            }));
        }
        else {
            setFormMicSampling(_search => ({
                ..._search,
                sample_Form: {
                    ..._search?.sample_Form,
                    subject: null,
                }
            }));
        }
    }

    const handleChangeQuantity = async (e) => {
        const _quantity = e?.target?.value;

        if (e !== null && e?.target?.value !== undefined && e?.target?.value !== "") {
            setFormMicSampling(_search => ({
                ..._search,
                sample_Form: {
                    ..._search?.sample_Form,
                    quantity: _quantity
                }
            }));
        }
        else {
            setFormMicSampling(_search => ({
                ..._search,
                sample_Form: {
                    ..._search?.sample_Form,
                    quantity: null,
                }
            }));
        }
    }

    const handleChangeObservations = async (e) => {
        const _observations = e?.target?.value;

        if (e !== null && e?.target?.value !== undefined && e?.target?.value !== "") {
            setFormMicSampling(_search => ({
                ..._search,
                sample_Form: {
                    ..._search?.sample_Form,
                    observations: _observations
                }
            }));
        }
        else {
            setFormMicSampling(_search => ({
                ..._search,
                sample_Form: {
                    ..._search?.sample_Form,
                    observations: null,
                }
            }));
        }
    }

    // ! TEMPERATURE
    const handleRequiredTemperature = async (e) => {
        const _temperature = e?.target?.checked;

        if (e !== null && e?.target?.checked !== undefined && e?.target?.checked !== "") {
            setFormMicSampling(_search => ({
                ..._search,
                sample_Form: {
                    ..._search?.sample_Form,
                    required_temperature: _temperature
                }
            }));

            if (_temperature) {
                getTypeThermometers()
            }
        }
        else createSweet("warning", "warning", "Temperatura", "No se puede agragar temperatura");
    }

    const getTypeThermometers = async () => {
        const thermometers = await getThermometers();

        if (thermometers?.length > 0) {
            const list = thermometers?.map(_find => {
                return {
                    value: _find?.id_thermometer,
                    label: _find?.name_thermometer,
                    factor: _find?.correction_factor
                }
            });
            setListThermometer(list);
        }
        else createSweet("warning", "warning", "Muestra", "Sin resultados");
    }

    const handleChangeThermometers = async (e, isValid) => {
        if (e !== null && e?.value !== undefined && e?.value !== "") {
            setFormMicSampling(_search => ({
                ..._search,
                sample_Form: {
                    ..._search?.sample_Form,
                    id_thermometer: {
                        value: e?.value,
                        label: e?.label,
                    },
                    factor_correction: e?.factor,
                    temperature: isValid === undefined ? "" : _search?.sample_Form?.temperature,
                },
                is_edit_thermometer: false
            }));
        }
        else {
            setFormMicSampling(_search => ({
                ..._search,
                sample_Form: {
                    ..._search?.sample_Form,
                    id_thermometer: null,
                    factor_correction: ""
                }
            }));
        }
    };

    const handleChangeTemperature = async (e, isValid) => {
        if (e !== null && e?.target?.value !== undefined && e?.target?.value !== "") {

            let _temperature = parseFloat(e?.target?.value);
            let _factor_correction = isValid === undefined ? parseFloat(formMicSampling?.sample_Form?.factor_correction) : isValid;

            // ? FACTOR CORRECTION
            let _sumCorrection = _temperature + _factor_correction;
            _sumCorrection = parseFloat(_sumCorrection.toFixed(1));


            setFormMicSampling(_search => ({
                ..._search,
                sample_Form: {
                    ..._search?.sample_Form,
                    temperature: _temperature,
                    factor_correction2: _sumCorrection
                }
            }));
        }
        else {
            setFormMicSampling(_search => ({
                ..._search,
                sample_Form: {
                    ..._search?.sample_Form,
                    temperature: null,
                }
            }));
        }
    };
    // ! END TEMPERATURE


    // ! CREATE SAMPLE
    const saveCreateSample = async () => {

        let _name = nameSampling

        const response = await saveSampleM({
            name: _name
        });
        if (response.code === 200) {
            getSamplesList()
            getTypeSites();

            let _newArray = listSample;

            const lastSample = _newArray[_newArray.length - 1];

            const newId = lastSample ? lastSample.value + 1 : 1;

            setFormMicSampling(_search => ({
                ..._search,
                sample_Form: {
                    ..._search?.sample_Form,
                    id_mic_sample: {
                        value: newId,
                        label: _name,
                    }
                }
            }));
            toggleSample();

        } else createSweet("wanirnig", "warning", response?.data?.message);
    }

    // ! CREATE SITE
    const saveCreateSite = async () => {
        const response = await saveSite({ name: nameSite });

        if (response.code === 200) {
            getTypeSites()

            let _newArray = listSite;

            const lastSite = _newArray[_newArray.length - 1];

            const newId = lastSite ? lastSite.value + 1 : 1;

            setFormMicSampling(_search => ({
                ..._search,
                sample_Form: {
                    ..._search?.sample_Form,
                    id_mic_site: {
                        value: newId,
                        label: nameSite,
                    },
                    id_mic_site_areas: null
                }
            }));
        }
        toggleSite();

    };





    //#endregion

    //*TOGGLE EXAMS
    const handleToggleSamplings = () => {
        setModalSamplings(prev => !prev);
    };

    const handlePreviewSamplings = () => {
        setFormMicSampling(prev => ({
            ...prev,
            validate_cancell: false
        }));

        setModalSamplings(true);
    };

    const saveSamplings = async () => {

        setLoadingSamplings(true);

        if (formMicSampling?.sample_Form?.id_mic_site === null || formMicSampling?.sample_Form?.id_mic_site === 0) {
            createSweett("Guardar Muestreo", `Se debe capturar el campo "Sitio".`, "error");
            handleToggleSamplings();
            return;
        }

        if (formMicSampling?.sample_Form?.id_mic_sample === null || formMicSampling?.sample_Form?.id_mic_sample === 0) {
            createSweett("Guardar Muestreo", `Se debe capturar el campo "Descripción de la muestra".`, "error");
            handleToggleSamplings()
            return;
        }

        //loadingSamplings

        const response = await saveSampling({
            date_collected: "",
            factor_correction: formMicSampling?.sample_Form?.factor_correction === null ? 0 : formMicSampling?.sample_Form?.factor_correction,
            folio: formMicSampling?.sample_Form?.folio,
            id_mic_detail_sample: formMicSampling?.sample_Form?.id_mic_detail_sample,
            id_mic_sample: formMicSampling?.sample_Form?.id_mic_sample.value,
            id_mic_sampling: formMicSampling?.sample_Form?.id_mic_sampling,
            id_mic_site: formMicSampling?.sample_Form?.id_mic_site.value,
            id_mic_site_areas: (url_helen !== "https://almass.helen-sw.com" && url_helen !== "https://pyrsa.helen-sw.com") ? (formMicSampling?.sample_Form?.id_mic_site_areas.value) : null,
            id_mic_type_sample: formMicSampling?.sample_Form?.id_mic_type_sample,
            id_patient: null,
            id_quoter: formMicSampling?.sample_Form?.id_quoter,
            id_quoter_type_sample: formMicSampling?.sample_Form?.id_quoter_type_sample,
            id_thermometer: formMicSampling?.sample_Form?.required_temperature === true ? formMicSampling?.sample_Form?.id_thermometer.value : null,
            not_collected: false,
            observations: formMicSampling?.sample_Form?.observations === null ? "" : formMicSampling?.sample_Form?.observations,
            quantity: formMicSampling?.sample_Form?.quantity === null ? "" : formMicSampling?.sample_Form?.quantity,
            required_temperature: formMicSampling?.sample_Form?.required_temperature === null ? false : formMicSampling?.sample_Form?.required_temperature,
            temperature: formMicSampling?.sample_Form?.temperature === null ? "" : formMicSampling?.sample_Form?.temperature,
            subject: formMicSampling?.sample_Form?.subject === null ? "" : formMicSampling?.sample_Form?.subject,
            id_user_do_sampling: url_helen === pyrsa ? (mSelectUser?.value ?? null) : null,
        });

        if (response.code === 200) {
            setLoadingSamplings(false);

            getSearchFilter(true)

        } else createSweet("wanirnig", "warning", response?.data?.message);
    }

    // * EDIT SAMPLINGS
    const saveEditSamplings = async () => {

        setLoadingSamplings(true);

        if (formMicSampling?.sample_Form?.id_mic_site === null || formMicSampling?.sample_Form?.id_mic_site === 0) {
            createSweett("Guardar Muestreo", `Se debe capturar el campo "Sitio".`, "error");
            handleToggleSamplings();
            return;
        }

        if (formMicSampling?.sample_Form?.id_mic_sample === null || formMicSampling?.sample_Form?.id_mic_sample === 0) {
            createSweett("Guardar Muestreo", `Se debe capturar el campo "Descripción de la muestra".`, "error");
            handleToggleSamplings()
            return;
        }

        const response = await saveUpdateSampling({
            date_collected: "",
            factor_correction: formMicSampling?.sample_Form?.factor_correction === null ? 0 : formMicSampling?.sample_Form?.factor_correction,
            folio: formMicSampling?.sample_Form?.folio,
            id_mic_detail_sample: formMicSampling?.sample_Form?.id_mic_detail_sample,
            id_mic_sample: formMicSampling?.is_edit_id_mic_sample ? formMicSampling?.sample_Form?.id_mic_sample : formMicSampling?.sample_Form?.id_mic_sample.value,
            id_mic_sampling: formMicSampling?.sample_Form?.id_mic_sampling,
            id_mic_site: formMicSampling.is_edit_site ? formMicSampling?.sample_Form?.id_mic_site : formMicSampling?.sample_Form?.id_mic_site.value,
            id_mic_site_areas: (url_helen !== "https://almass.helen-sw.com" && url_helen !== "https://pyrsa.helen-sw.com") ? (formMicSampling?.sample_Form?.id_mic_site_areas.value) : null,
            id_mic_type_sample: formMicSampling?.sample_Form?.id_mic_type_sample,
            id_patient: null,
            id_quoter: formMicSampling?.sample_Form?.id_quoter,
            id_quoter_type_sample: formMicSampling?.sample_Form?.id_quoter_type_sample,
            id_thermometer: formMicSampling?.sample_Form?.required_temperature === true ? formMicSampling?.sample_Form?.id_thermometer.value : null,
            not_collected: false,
            observations: formMicSampling?.sample_Form?.observations === null ? "" : formMicSampling?.sample_Form?.observations,
            quantity: formMicSampling?.sample_Form?.quantity === null ? "" : formMicSampling?.sample_Form?.quantity,
            required_temperature: formMicSampling?.sample_Form?.required_temperature === null ? false : formMicSampling?.sample_Form?.required_temperature,
            temperature: formMicSampling?.sample_Form?.temperature === null ? "" : formMicSampling?.sample_Form?.temperature,
            subject: formMicSampling?.sample_Form?.subject === null ? "" : formMicSampling?.sample_Form?.subject,
            id_user_do_sampling: url_helen === pyrsa ? (mSelectUser?.value ?? null) : null,
        });

        if (response.code === 200) {
            setLoadingSamplings(false);
            getSearchFilter(true)

        } else createSweet("wanirnig", "warning", response?.data);
    }

    // * VIEW SAMPLINGS
    const handleViewSamplings = (_id_quoter_type_sample) => {
        if (_id_quoter_type_sample !== null && _id_quoter_type_sample !== "" && _id_quoter_type_sample !== undefined) {

            let _search = formMicSampling?.samples.find(x => x.id_quoter_type_sample === _id_quoter_type_sample);

            if (_search !== null) {
                setFormMicSampling({
                    ...formMicSampling,
                    sample_Detail: _search,
                    is_detail: true
                });
            }
            else {
                setFormMicSampling({
                    ...formMicSampling,
                    sample_Detail: _search,
                    is_detail: false
                });
            }
        }
        else createSweet("warning", "warning", "Muestreo", "No se encontro ningún resultado");
    }

    const handleDetermination = (_valid) => {
        setFormMicSampling({
            ...formMicSampling,
            is_determination: _valid
        })
    }

    // #region SAMPLING PLAN
    const handleChangeFirm = (myRef, type) => {
        const Draw = myRef.current;
        if (type === "responsable") {
            setFormMicSampling(_search => ({
                ..._search,
                firm_sampler: (Draw.getDataURL('png'))
            }));

        } else if (type === "cliente") {
            setFormMicSampling(_search => ({
                ..._search,
                firm_client: (Draw.getDataURL('png'))
            }));
        } else if (type === "supervisor") {
            setFormMicSampling(_search => ({
                ..._search,
                firm_superv: (Draw.getDataURL('png'))
            }));
        }
    }

    const repeatFirm = (myRef, type) => {

        const Draw = myRef.current;
        if (Draw && Draw.eraseAll) {
            Draw.eraseAll();
        }

        if (type === "sampler") {
            setFormMicSampling(prevState => ({
                ...prevState,
                firm_sampler: null
            }));
        } else if (type === "client") {
            setFormMicSampling(prevState => ({
                ...prevState,
                firm_client: null
            }));
        } else if (type === "superv") {
            setFormMicSampling(prevState => ({
                ...prevState,
                firm_superv: null
            }));
        }
    };

    const handleChangeObservationsPlan = async (e) => {
        const _observations = e?.target?.value;

        if (e !== null && e?.target?.value !== undefined && e?.target?.value !== "") {
            setFormMicSampling(_search => ({
                ..._search,
                observations: _observations
            }));
        }
        else {
            setFormMicSampling(_search => ({
                ..._search,
                observations: null
            }));
        }
    }

    const handleChangeNumPlan = async (e) => {
        const _observations = e?.target?.value;

        if (e !== null && e?.target?.value !== undefined && e?.target?.value !== "") {
            setFormMicSampling(_search => ({
                ..._search,
                sampling_plan: _observations
            }));
        }
        else {
            setFormMicSampling(_search => ({
                ..._search,
                sampling_plan: null
            }));
        }
    }

    const saveSamplingPlan = async () => {

        const response = await saveQuoter({
            cotizacion: formMicSampling?.quoter,
            observations: formMicSampling?.observations,
            firm_sampler: formMicSampling?.firm_sampler,
            firm_client: formMicSampling?.firm_client,
            firm_superv: formMicSampling?.firm_superv,
            sampling_plan: formMicSampling?.sampling_plan,
        });

        if (response.code === 200) {
            createSweet("success", "success", "Plan de Muestreo", "Se han guardado correctamente los datos");

            setFormMicSampling({
                ...formMicSampling,
                quoter: response?.data?.cotizacion ?? {},
                firm_sampler_png: response?.data?.firm_sampler ?? null,
                firm_client_png: response?.data?.firm_client ?? null,
                firm_superv_png: response?.data?.firm_superv ?? null,
                observations: response?.data?.observations ?? null,
                sampling_plan: response?.data?.sampling_plan ?? null,
                is_view: 3
            });
        } else createSweet("wanirnig", "warning", response?.data?.message);
    }
    // #endregion

    // #region SAVE MICRO WORKORDER
    //*TOGGLE SAVE
    const handleToggleValid = () => {
        setModalValid(!modalValid)
    }

    // ? CONFIGURATION PAYMENT COMPANY

    const handleChangePayMethod = (e) => {
        if (e.value !== "" && e !== null) {
            setFormMicSampling({
                ...formMicSampling,
                payment_company: e?.value === "1" ? true : false
            })
        }
    }

    // ! PAYMENT METHOD
    const handleAddPayMethod = () => {
        setOptionsPayment(prev => ({
            ...prev,
            listPayMethods: [
                ...prev?.listPayMethods,
                {
                    id_pay_method: 0,
                    amount: 0.0,
                    is_edited: false,
                    deleted: false,
                    id_branch: 0
                }
            ]
        }));
    };

    const handleDeletePayMethod = (_key) => {

        let _array = [...optionsPayment.listPayMethods];
        let _amount = 0;

        if (_array.length > 1) {
            _array.splice(_key, 1);
        }

        _array.forEach(_find => {
            _amount += parseFloat(_find.amount);
        });

        setOptionsPayment({
            ...optionsPayment,
            listPayMethods: _array
        });

    };

    // ? CONFIGURATION SELECT
    const handleGiveChange = (e, name) => {
        const newValue = e?.target?.value;
        const updatedList = [...optionsPayment.listPayMethods];
        updatedList[e.target.dataset.id][name] = newValue;

        setOptionsPayment(prevState => ({
            ...prevState,
            listPayMethods: updatedList
        }));

    };

    // ? CONFIGURATION SELECT
    const handleGiveMethod = (e, name) => {
        const newValue = e?.target?.value;
        const updatedList = [...optionsPayment.listPayMethods];
        updatedList[e.target.dataset.id][name] = newValue;

        setOptionsPayment(prevState => ({
            ...prevState,
            listPayMethods: updatedList
        }));
    };

    // ! INVOICES
    const handleRequiredInvoice = async (e) => {
        const _invoices = e?.target?.checked;

        if (e !== null && e?.target?.checked !== undefined && e?.target?.checked !== "") {
            setFormMicSampling(_search => ({
                ..._search,
                require_invoice: _invoices
            }));

        }
        else createSweet("warning", "warning", "Temperatura", "No se puede marcar la factura");
    }


    const saveMicroWorkorder = async (_type) => {

        let studyDeliveryToSave = formMicSampling?.study_delivery || "";
        if (studyDeliveryToSave) {
            // console.log("📅 La orden ya tiene fecha:", studyDeliveryToSave);
        }

        else {

            const confirmed = await showCustomAlertConfirm({
                type: "warning",
                title: "Fecha de entrega",
                message: `
                    Selecciona una <b>fecha de entrega</b> para esta orden.
                    <br/><br/>
                    <small>
                        La fecha de entrega es opcional.
                        Puedes asignarla ahora o continuar sin fecha.
                    </small>
                `,
                buttonText: "Agregar fecha",
                cancelText: "Omitir, generar orden",
                showDatePicker: true
            });

            // console.log("📅 Respuesta del alert:", confirmed);
            if (confirmed === undefined) {
                return;
            }

            if (confirmed === null) {
                studyDeliveryToSave = "";
            }

            else {
                studyDeliveryToSave = confirmed;
                setFormMicSampling(prev => ({
                    ...prev,
                    study_delivery: confirmed
                }));
            }
        }


        setLoadingMic(true);
        const response = await saveWorkOrderMicro({
            id_branch,
            id_commercial_line,
            id_quoter: formMicSampling?.id_quoter,
            iva: optionsTotal.tax,
            listPayMethods: optionsPayment?.listPayMethods,
            required_invoice_patient: formMicSampling?.is_company !== null
                ? false
                : formMicSampling?.require_invoice,
            required_invoice: formMicSampling?.require_invoice,
            payment_company: formMicSampling?.payment_company,
            calculate_amount: optionsTotal?.total,
            study_delivery: studyDeliveryToSave,

        });


        if (response.code === 200) {

            setLoadingMic(false);

            createSweet(
                "success",
                "success",
                "Muestreo",
                "Se generó correctamente"
            );

            history.push("../../dashboard/default");

        } else {

            setLoadingMic(false);

            createSweett(
                "Muestreo",
                response?.data,
                "error"
            );
        }
    };

    // #endregion

    // #region SAVE SAMPLINGG CEDIMI
    const handleNavigateSampling = (_code) => {
        history.push("../cotizacion");
    }

    const saveSamplingPlanCedimi = async () => {
        const response = await saveQuoter({
            cotizacion: formMicSampling?.quoter,
            observations: null,
            firm_sampler: null,
            firm_client: null,
            firm_superv: null,
            sampling_plan: formMicSampling?.sampling_plan,
        });

        if (response.code === 200) {
        } else createSweet("wanirnig", "warning", response?.data?.message);
    }

    const saveSample = async (_type) => {
        setLoadingCedimi(true)
        let studyDeliveryToSave = formMicSampling?.study_delivery || "";
        if (studyDeliveryToSave) {
            // console.log("📅 La orden ya tiene fecha:", studyDeliveryToSave);
        }

        else {

            const confirmed = await showCustomAlertConfirm({
                type: "warning",
                title: "Fecha de entrega",
                message: `
                    Puede agregar una <b>fecha de compromiso</b> para esta orden.
                    <br/><br/>
                    <small>Este campo es <b>opcional</b>. Si no desea asignarla en este momento, puede omitir este paso y generar la orden.</small>
                `,
                buttonText: "Agregar fecha",
                cancelText: "Omitir, generar orden",
                showDatePicker: true
            });

            if (confirmed === undefined) {
                return;
            }

            if (confirmed === null) {
                studyDeliveryToSave = "";
            }

            else {
                studyDeliveryToSave = confirmed;
                setFormMicSampling(prev => ({
                    ...prev,
                    study_delivery: confirmed
                }));
            }
        }


        const response = await saveWorkOrderMicro({
            id_branch: id_branch,
            id_commercial_line: id_commercial_line,
            id_quoter: formMicSampling?.id_quoter,
            iva: optionsTotal?.tax ?? 16,
            listPayMethods: [
                {
                    "id_pay_method": 1,
                    "amount": optionsTotal?.total ?? 0,
                    "id_branch": id_branch
                }
            ],
            required_invoice_patient: false,
            required_invoice: true,
            payment_company: true,
            calculate_amount: optionsTotal?.total,
            study_delivery: studyDeliveryToSave,

        });

        saveSamplingPlanCedimi()

        if (response.code === 200) {
            setLoadingCedimi(false)
            createSweet("success", "success", "Muestreo", "Se genero correctamente");
            history.push("../../dashboard/default")

        } else
            createSweett("Guardar Muestreo", response?.data?.message, "error");


    }

    const customStyles = {
        singleValue: (provided) => ({
            ...provided,
            color: '#495057',
        }),
    };

    const handleGoBack = () => {
        history.goBack();
    }

    // #endregion


    const handleApply = (event, picker) => {

        const fecha = picker.startDate.format("YYYY-MM-DD HH:mm");
        setFormMicSampling(prev => ({
            ...prev,
            study_delivery: fecha
        }));
    };

    const handleAutoSave = (event, picker) => {

        const fecha = picker.startDate.format("YYYY-MM-DD HH:mm");

        setFormMicSampling(prev => ({
            ...prev,
            study_delivery: fecha
        }));
    };

    const study_delivery = formMicSampling.study_delivery;
    // console.log("🚀 ~ useMicSampling ~ formMicSampling:", formMicSampling)

    //#region Branch 

    const getUsers = async () => {
        setLoadingUsers(true);

        try {
            const usersData = await handleRequest(
                "GET",
                "Users/ListAllUsers",
                "Report"
            );

            if (Array.isArray(usersData)) {
                const formatted = usersData.map(user => ({
                    value: user.id_component,
                    label: user.component
                }));

                setUsers(formatted);
            } else {
                setUsers([]);
            }

        } finally {
            setLoadingUsers(false);
        }
    };


    const handleSelectValues = (e, name) => {
        if (name === "mSelectUser") {
            setMSelectUser(e);
        }
    };
    //#endregion

    //#region GLOBAL REQUEST
    const handleRequest = async (method, methodUrl, nameMethod, body = null) => {
        let requestOptions = {
            method: method
        };

        if (body !== null) {
            requestOptions = {
                ...requestOptions,
                body: JSON.stringify(body)
            };
        }

        const response = await sendRequest(requestOptions, methodUrl);

        if (response.code === 200) {
            return response.data;
        }
        else if (response.code === 401) {
            validarSesion(history, response.code, handleRequest);
        }
        else if (response.code === 500) {
            createSweet("error", "error", nameMethod, "Ocurrio un error en el servidor");
        }
        else {
            createSweet("warning", "warning", nameMethod, response.data.msg);
        }

        return null;
    }

    //#endregion




    return {

        // * FORM SAMPLE
        loadingQuoter, formMicSampling, handleView,

        // * INPUTS
        handleNotCollected, handleToggleCollected, modalCollected, dataCollected,

        // * SAVE SAMPLINGS
        saveDetailSamplingsNotCollected, handleSearchSampling, handleResetSamplings, cancell_Samplings,

        // * SAMPLE FORM
        handleChangeSites, handleChangeArea, handleChangeSample, handleChangeQuantity, handleChangeObservations,
        handleRequiredTemperature, handleChangeThermometers, handleChangeTemperature, handleChangeSubject,

        // * LIST SAMPLES
        listSite, listArea, listSample, listThermometer,

        // * SAVE SAMPLINGS
        handleToggleSamplings, modalSamplings, handlePreviewSamplings, saveSamplings, loadingSamplings,

        // * VIEWS
        handleViewSamplings, handleDetermination, listNot,

        // * SAMPLING PLAN
        handleChangeFirm, repeatFirm, canvasRef1, canvasRef2, canvasRef3,
        handleChangeObservationsPlan, handleChangeNumPlan, saveSamplingPlan,

        // * CALCULATE PRICES
        optionsTotal, total_tax,

        // * SAVE SAMPLINGS
        listPay, optionsPayment, handleAddPayMethod, handleDeletePayMethod,
        handleGiveChange, handleGiveMethod, saveMicroWorkorder, loadingMic, handleToggleValid, modalValid,
        handleChangePayMethod,

        // * INVOICES
        handleRequiredInvoice,

        // * QUATATION MIC
        handleNavigateSampling,

        // ? GLOBAL
        url_helen,

        // ? new
        handleNewSample, modalSample, toggleSample, handleText, saveCreateSample,

        // ! CONFIGURATION CEDIMI SAVE MICRO WORK ORDER
        saveSample, loadingCedimi, nameBranch, customStyles, handleGoBack,

        // * MODAL CREATE SITE
        handleNewSite, modalSite, toggleSite, handleTextSite, saveCreateSite,

        // * EDIT SAMPLINGS
        editSearchSampling, saveEditSamplings,

        //* delivery date
        minDate,
        handleApply,
        handleAutoSave,
        study_delivery,

        //* CUSTOM ALERT
        customAlert,

        // * RESPONSABLE SANITARIO
        users,
        loadingUsers,
        mSelectUser,
        handleSelectValues


    }
}